<template>
  <div class="tawk-chat-container">
    <!-- Custom Header Bar -->
    <div v-if="showChat" class="custom-header">
      <span class="header-title">Boho Support</span>
      <button class="close-btn" @click="closeChat">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18M6 6L18 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    
    <!-- Loading -->
    <div v-if="!showChat" class="loading">
      <loading-spinner />
    </div>
  </div>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import { localeChanged, localize } from 'vee-validate'
import { locales } from '@/libs/i18n/all-locales'
import { sha256 } from 'js-sha256'
import LoadingSpinner from '@/components/LoadingSpinner'

export default {
  name: 'TawkChatMobile',
  components: {
    LoadingSpinner,
  },
  data() {
    return {
      showChat: false,
      user: null,
    }
  },
  created() {
    console.log('TawkChatMobile component created')
    
    const token = this.$cookies.get('token')
    const apiKey = this.$cookies.get('api-key') || 'zBqONnh0Osv0Q4EONtb74hGjhZKSzm'
    const locale = this.$cookies.get('locale')

    if (locale) {
      const selectedLocale = locales.find(l => l.locale === locale)

      if (selectedLocale) {
        this.updateLocale(locale)
      } else {
        this.updateLocale('en')
      }
    }

    if (token && apiKey) {
      useJwt.setToken(null)
      useJwt.setApiKey(null)

      useJwt.setToken(token)
      useJwt.setApiKey(apiKey)

      setTimeout(() => {
        this.getMe()
      }, 33)
    } else {
      this.getMe()
    }
  },
  methods: {
    getMe() {
      useJwt.getMe()
        .then(response => {
          this.user = response.data.body
          this.$store.dispatch('auth/updateUser', response.data.body)
          this.loadTawkTo()
        })
        .catch(error => {
          console.error('Error fetching user:', error)
          this.loadTawkTo()
        })
    },
    loadTawkTo() {
      const user = this.user

      console.log('loadTawkTo called')

      // Eğer Tawk zaten yüklüyse, sadece maximize et
      if (window.Tawk_API && typeof window.Tawk_API.maximize === 'function') {
        console.log('Tawk already loaded, using existing instance')

        if (user) {
          const tawkToApiKey = process.env.VUE_APP_TAWKTO_API_KEY || '58c155d1e79c1935a0df0a6af68767f732eb0fea'
          const email = user.email || ''
          const hash = sha256.hmac(tawkToApiKey, email)

          window.Tawk_API.setAttributes({
            username: user.userName || '',
            name: user.userName || '',
            email: email,
            hash: hash,
          }, (error) => {
            if (error) {
              console.error('Tawk setAttributes error:', error)
            }
          })
        }

        window.Tawk_API.maximize()
        this.showChat = true
        return
      }

      // Tawk yüklü değilse yükle
      window.Tawk_API = window.Tawk_API || {}
      window.Tawk_LoadStart = new Date()

      window.Tawk_API.onLoad = () => {
        console.log('Tawk onLoad triggered!')
        this.showChat = true

        if (user) {
          const tawkToApiKey = process.env.VUE_APP_TAWKTO_API_KEY || '58c155d1e79c1935a0df0a6af68767f732eb0fea'
          const email = user.email || ''
          const hash = sha256.hmac(tawkToApiKey, email)

          window.Tawk_API.setAttributes({
            username: user.userName || '',
            name: user.userName || '',
            email: email,
            hash: hash,
          }, (error) => {
            if (error) {
              console.error('Tawk setAttributes error:', error)
            }
          })
        }

        setTimeout(() => {
          if (window.Tawk_API.maximize) {
            window.Tawk_API.maximize()
          }
          // iframe'leri aşağı it
          this.adjustTawkPosition()
        }, 100)
      }

      const s1 = document.createElement('script')
      const s0 = document.getElementsByTagName('script')[0]
      s1.async = true
      s1.src = 'https://embed.tawk.to/5eb1233581d25c0e5848e3f3/default'
      s1.charset = 'UTF-8'
      s1.setAttribute('crossorigin', '*')
      s0.parentNode.insertBefore(s1, s0)
    },
    closeChat() {
      console.log('Close button clicked')
      
      // Tawk'ı minimize et
      if (window.Tawk_API && window.Tawk_API.minimize) {
        window.Tawk_API.minimize()
      }
      
      // iOS'a event gönder
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iosListener) {
        window.webkit.messageHandlers.iosListener.postMessage({ key: 'tawk-chat-closed' })
      }
      
      // Android'e event gönder
      if (window.AndroidApp) {
        window.AndroidApp.sendData(JSON.stringify({ key: 'tawk-chat-closed' }))
      }
    },
    adjustTawkPosition() {
      const headerHeight = 56
      const tawkHeaderHeight = 70 // Tawk'ın kendi header yüksekliği (yaklaşık)
      
      const adjustIframes = () => {
        const iframes = document.querySelectorAll('iframe[title="chat widget"]')
        iframes.forEach(iframe => {
          // iframe'i yukarı kaydır ki Tawk header'ı ekran dışına çıksın
          iframe.style.setProperty('top', (headerHeight - tawkHeaderHeight) + 'px', 'important')
          iframe.style.setProperty('bottom', '0', 'important')
          iframe.style.setProperty('height', `calc(100vh - ${headerHeight - tawkHeaderHeight}px)`, 'important')
          iframe.style.setProperty('max-height', `calc(100vh - ${headerHeight - tawkHeaderHeight}px)`, 'important')
          iframe.style.setProperty('min-height', `calc(100vh - ${headerHeight - tawkHeaderHeight}px)`, 'important')
          iframe.style.setProperty('clip-path', `inset(${tawkHeaderHeight}px 0 0 0)`, 'important')
        })
      }
      
      // Birkaç kez dene çünkü Tawk style'ları sonradan değiştirebilir
      adjustIframes()
      setTimeout(adjustIframes, 200)
      setTimeout(adjustIframes, 500)
      setTimeout(adjustIframes, 1000)
      setTimeout(adjustIframes, 2000)
    },
    updateLocale(locale) {
      this.$i18n.locale = locale
      localize(locale)
      localeChanged()
      localStorage.setItem('locale', locale)

      if (locale === 'ar') {
        localStorage.setItem('isRTL', 'on')
      }
      this.$store.commit('appConfig/TOGGLE_RTL', locale === 'ar')

      this.updateLocaleFromServer(locale)
    },
    updateLocaleFromServer(lang) {
      if (lang) {
        useJwt.updateLanguage(lang)
      }
    },
  },
  beforeDestroy() {
    if (window.Tawk_API && window.Tawk_API.hideWidget) {
      window.Tawk_API.hideWidget()
    }
  },
}
</script>

<style scoped>
.tawk-chat-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  z-index: 1;
}

.custom-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 56px;
  background: linear-gradient(135deg, #e91e8c 0%, #f06292 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  z-index: 2147483647;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.header-title {
  color: white;
  font-size: 18px;
  font-weight: 600;
}

.close-btn {
  background: transparent;
  border: none;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.close-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.close-btn:active {
  background-color: rgba(255, 255, 255, 0.3);
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>

<style>
/* Tawk widget'ı ayarla - header'ı clip ile gizle */
iframe[title="chat widget"],
.tawk-max-container,
.tawk-max-container iframe {
  top: -14px !important;
  bottom: 0 !important;
  height: calc(100vh + 14px) !important;
  max-height: calc(100vh + 14px) !important;
  min-height: calc(100vh + 14px) !important;
  clip-path: inset(70px 0 0 0) !important;
}

/* Minimize button'ı gizle */
.tawk-min-container {
  display: none !important;
}
</style>
